<script setup lang="ts">
import {
    DropdownMenuContent,
    type DropdownMenuContentEmits,
    type DropdownMenuContentProps,
    DropdownMenuPortal,
    useForwardPropsEmits,
} from "radix-vue";
import { cn } from "@/lib/utils";

const props = withDefaults(
    defineProps<DropdownMenuContentProps & { class?: string }>(),
    {
        sideOffset: 4,
    },
);
const emits = defineEmits<DropdownMenuContentEmits>();

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
    <DropdownMenuPortal>
        <DropdownMenuContent
            :class="[
                cn(
                    'rounded-lg border-iron-200 bg-white p-1 pt-1.5 text-iron-500 shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] overflow-hidden border',

                    props.class,
                ),
            ]"
            v-bind="forwarded"
        >
            <slot />
        </DropdownMenuContent>
    </DropdownMenuPortal>
</template>
